import {create, destroy, get, update} from "custom/demo/requests/admin/decks";
import Field from "components/helpers/form/field";
import useForm from "custom/demo/helpers/admin/use-form";

const imagePackOptions = [{name: "linear", value: "linear"}, {name: "flat", value: "flat"}];

const defaults = {
  color: "",
  custom_share_images: false,
  description: "",
  hidden: false,
  icon: "",
  image_pack: "linear",
  key: "",
  name: "",
  position: ""
};

export default function Form() {
  const {id, onChange, onDestroy, onSubmit, record} = useForm({
    actions: {create, destroy, get, update}, defaults, path: "/admin/decks"
  });

  return (
    <div className="container">
      <h1>Deck</h1>
      <form onSubmit={onSubmit}>
        <Field
          label="Position"
          name="position"
          onChange={onChange}
          placeholder="Position"
          required={true}
          type="number"
          value={record.position}
        />
        <Field
          label="Key"
          name="key"
          onChange={onChange}
          placeholder="Deck ID"
          required={true}
          value={record.key}
        />
        <Field
          label="Name"
          name="name"
          onChange={onChange}
          placeholder="Name"
          required={true}
          value={record.name}
        />
        <Field
          checked={record.hidden}
          label="Hidden"
          name="hidden"
          onChange={onChange}
          type="checkbox"
        />
        <Field
          label="Description"
          name="description"
          onChange={onChange}
          placeholder="Description"
          value={record.description}
        />
        <Field
          label="Color"
          name="color"
          onChange={onChange}
          placeholder="#FFFFFF"
          value={record.color}
        />
        <Field
          label="Icon"
          name="icon"
          onChange={onChange}
          placeholder="Icon"
          value={record.icon}
        />
        <Field
          label="Image Pack"
          name="image_pack"
          onChange={onChange}
          options={imagePackOptions}
          type="select"
          value={record.image_pack}
        />
        <Field
          checked={record.custom_share_images}
          label="Custom Share Images"
          name="custom_share_images"
          onChange={onChange}
          type="checkbox"
        />
        <div className="flex gap-2 mt-4">
          <button className="btn btn-blue" type="submit">Save</button>
          {id && <button className="btn btn-red" onClick={onDestroy} type="button">Delete</button>}
        </div>
      </form>
    </div>
  );
}
